// import { proofOfIncomeState } from "../temp";
import { PageType, State } from "../types";

// export const initialState: State = proofOfIncomeState;

export const initialState: State = {
  page: PageType.LANDING,
  contactInformationCorrect: "",
  newCreditLimit: "",
  personalInformation: {
    relationshipStatus: "",
    numberOfDependants: "",
  },
  residentialAddress: {
    residentialStatus: "",
    mortgageOrRent: "",
    timeAtCurrentAddress: {
      years: "",
      months: "",
    },
  },
  employmentDetails: {
    employmentStatus: "",
    occupation: "",
    timeWithCurrentEmployer: {
      years: "",
      months: "",
    },
  },
  income: {
    netIncome: {
      amount: "",
      frequency: "monthly",
    },
    otherIncome: {
      amount: "",
      frequency: "monthly",
    },
    otherSourcesOfIncome: "",
  },
  monthlyExpenses: {
    shareLivingExpenses: "",
    expenses: {
      lifestyle: "",
      education: "",
      transport: "",
      insurances: "",
      utilities: "",
      personal: "",
    },
    totalExpenses: null,
  },
  additionalDebts: {
    haveAdditionalDebts: "",
    loanRepayments: "",
    totalCreditLimit: "",
    totalOwing: "",
  },
  nzAdditionalIncome: {
    amount: "",
    frequency: "monthly",
  },
  nzRevolvingMortgage: "0",
};
